/**
 * created by li si yi
 * 安全检测记录弹窗
 */
import React, {Component} from 'react';
import {Button, message, Modal, Popconfirm} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import SelectUserModal from "./SelectUserModal";

export default class BindingSites extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            contentVisible: false,//显示
            params: {
                userId: ''
            },
            isSelected: false,
            currentClick: {},
            dataSource: [],
            columns: [
                {
                    title: '媒体名称',
                    dataIndex: 'mediaName',
                    key: 'mediaName',
                    ellipsis: true,
                    width: 200,
                },
                {
                    title: '站点ID',
                    dataIndex: 'owner',
                    key: 'owner',
                    width: 200,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <div>{text ? text : ''}</div>
                        )
                    }
                },
                {
                    title: '已绑定用户',
                    dataIndex: 'vsbUserAccount',
                    key: 'vsbUserAccount',
                    width: 200,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div>{record.vsbUserName ? record.vsbUserName : ''}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    ellipsis: true,
                    width: 100,
                    render: (text, record) => {
                        const colors = {
                            color: this.themeBgColor,
                            marginRight: '10px',
                            cursor: 'pointer'
                        };
                        return (
                            record.vsbUserAccount ? <>
                                    <Popconfirm
                                        title="确定要解绑吗？"
                                        onConfirm={() => {
                                            this.bindVsbUser(record);
                                        }}
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <span style={colors}>解绑</span>
                                    </Popconfirm>
                                    <span style={{...colors, margin: 0}} onClick={() => {
                                        this.selectUserModal.showModal(false, record, this.state.currentClick, (selectData) => {
                                            this.getItemDataSource();
                                        });
                                    }}>更换</span> </> :
                                <span style={colors} onClick={() => {
                                    this.selectUserModal.showModal(false, record, this.state.currentClick,(selectData) => {
                                        this.getItemDataSource();
                                    });
                                    // console.log('record, this.state.currentClick',record, this.state.currentClick)
                                }}>绑定用户</span>
                        )
                    }
                },
            ],
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                {/*弹窗*/}
                {this.renderModal()}
                <SelectUserModal ref={ref => this.selectUserModal = ref}/>
            </div>
        )
    }

    renderModal() {
        const {contentVisible} = this.state;
        return (
            <>
                <Modal title={"绑定网站用户"} width={800}
                       visible={contentVisible}
                       onCancel={this.handleCancelContent}
                       bodyStyle={{height: 500}}
                       onOk={this.handleOk}
                       footer={<div style={{textAlign: "center"}}>
                           <Button onClick={()=>{
                               this.setState({contentVisible: false});
                           }} type={"primary"}>关闭</Button>
                       </div>}
                >
                    {/*<Search style={{width: 240, marginBottom: 24}} placeholder={'请输入姓名或者账号'}/>*/}
                    {/*选择用户列表*/}
                    {this.renderTable()}
                </Modal>
            </>
        )
    }

    // 解绑
    bindVsbUser = (record) => {
        message.destroy();
        let {currentClick} = this.state;
        let params = {
            "owner": record.owner,
            "userId": currentClick.userId,
        };
        // console.log('params', params, 'currentClick', currentClick);
        this.request({
            url: "/cm-sites-pms/website/unbindVsbUser",
            body: params,
            method: 'post',
            callBack: (res) => {
                // console.log(res);
                if (res) {
                    message.success('解绑成功');
                    this.getItemDataSource();
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 点击确定
    handleOk = () => {
        this.setState({
            contentVisible: false
        })
    };
    //列表
    renderTable = () => {
        const {dataSource, columns} = this.state;
        return (
            <div className={'recordStyle'} key={new Date().getTime()}>
                <Scrollbars style={{height: "calc(90vh - 400px)"}} autoHide>
                    <BaseTable rowKey="id" dataSource={dataSource} columns={columns}>
                    </BaseTable>
                </Scrollbars>
                {/*{this.renderFooter()}*/}
            </div>
        )
    };
    // 获取数据
    getItemDataSource = () => {
        this.request({
            url: "/cm-sites-pms/website/getWebSiteBindUserList",
            body: {userId: this.state.currentClick.userId},
            callBack: (res) => {
                let dataSource = [];
                if (res) {
                    dataSource = res;
                }
                this.setState({dataSource})
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 显示
    showModal = (record) => {
        // console.log('2222222222222222', record);
        this.setState({
            contentVisible: true,
        });
        this.state.currentClick = record;
        this.getItemDataSource();
    };
    // 取消
    handleCancelContent = () => {
        this.setState({contentVisible: false});
    };
}